import React from 'react'
import { Link } from 'react-router-dom';
import { Container, Row, Col, Card, Image } from 'react-bootstrap';
import divider from '../../images/about/lazerUygulamalari.jpg';
import lazer from '../../images/kozmetik/1600170895478.jpg';
import kilcal from '../../images/kozmetik/16001710716615.jpg';
import leke from '../../images/kozmetik/16001713555310.jpg';
import yenileme from '../../images/kozmetik/1600171539267.jpg';

import '../../styles/mainItem.css'

const LazerUygulamalari = () => {

    const handleScrollToTop = () => {
        // Smooth scroll to the top of the page
        window.scrollTo(0, 0)
    };

    return (
        <div className='main-page'>
            <Image src={divider} fluid className="about-img" />
            <div className='sub-items'>
                <Container>
                    <h1 className='mb-4'>Lazer Uygulamaları</h1>
                    <hr className='mb-4' />
                    <Row className='justify-content-md-start'>
                        <Col xs={12} sm={6} md={4} lg={3} xl={3} className='mb-3'>
                            <Card className='sub-items-card' as={Link} to="/lazer-uygulamalari/lazer-epilasyon" onClick={handleScrollToTop} >
                                <Card.Body>
                                    <p>LAZER EPİLASYON</p>
                                    <div className='card-image-frame'>
                                        <Image src={lazer} rounded className='exec-summary-images2' />
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col xs={12} sm={6} md={4} lg={3} xl={3} className='mb-3'>
                            <Card className='sub-items-card' as={Link} to="/lazer-uygulamalari/kilcal-damar-ve-varis-tedavisi" onClick={handleScrollToTop}>
                                <Card.Body>
                                    <p>LAZERLE KILCAL DAMAR VE VARİS TEDAVİSİ</p>
                                    <div className='card-image-frame'>
                                        <Image src={kilcal} rounded className='exec-summary-images2' />
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col xs={12} sm={6} md={4} lg={3} xl={3} className='mb-3'>
                            <Card className='sub-items-card' as={Link} to="/lazer-uygulamalari/leke-tedavisi" onClick={handleScrollToTop}>
                                <Card.Body>
                                    <p>LAZERLE LEKE TEDAVİSİ</p>
                                    <div className='card-image-frame'>
                                        <Image src={leke} rounded className='exec-summary-images2' />
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col xs={12} sm={6} md={4} lg={3} xl={3} className='mb-3'>
                            <Card className='sub-items-card' as={Link} to="/lazer-uygulamalari/cilt-yenileme" onClick={handleScrollToTop}>
                                <Card.Body>
                                    <p>LAZERLE CİLT YENİLEME</p>
                                    <div className='card-image-frame'>
                                        <Image src={yenileme} rounded className='exec-summary-images2' />
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    )
}

export default LazerUygulamalari